import { render, staticRenderFns } from "./DataRenderCanvas.vue?vue&type=template&id=32b3f543&scoped=true&"
import script from "./DataRenderCanvas.vue?vue&type=script&lang=js&"
export * from "./DataRenderCanvas.vue?vue&type=script&lang=js&"
import style0 from "./DataRenderCanvas.vue?vue&type=style&index=0&id=32b3f543&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b3f543",
  null
  
)

export default component.exports